import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import CustomerLoginForm from './components/CustomerLoginForm';
import BrandHeader from './components/BrandHeader';

const CustomerLoginScreen = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async ({ email, password }) => {
    setLoading(true);
    setError('');
    try {
      const { data, error: authError } = await supabase?.auth?.signInWithPassword({ email, password });
      if (authError) {
        setError(authError?.message || 'Invalid credentials. Please try again.');
      } else if (data?.user) {
        navigate('/customer-booking-screen', { replace: true });
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleGuestBooking = () => {
    navigate('/customer-booking-screen');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0A1628] via-[#1a2a4a] to-[#0A1628] flex items-center justify-center px-4 py-12">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-64 h-64 rounded-full bg-[#D4AF37]/5 blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 rounded-full bg-[#D4AF37]/5 blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#D4AF37]/3 blur-3xl" />
      </div>

      <div className="relative w-full max-w-md">
        <BrandHeader subtitle="Book • Track • Deliver" />

        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-8 shadow-2xl">
          <h2 className="text-2xl font-bold text-white mb-2 text-center">Welcome to OnTheGo</h2>
          <p className="text-white/60 text-sm text-center mb-8">Sign in to book rides and track your orders</p>

          <CustomerLoginForm onSubmit={handleLogin} loading={loading} error={error} />

          <div className="mt-4">
            <div className="relative flex items-center my-4">
              <div className="flex-1 border-t border-white/20" />
              <span className="px-3 text-white/40 text-xs">or</span>
              <div className="flex-1 border-t border-white/20" />
            </div>
            <button
              onClick={handleGuestBooking}
              className="w-full py-3 border border-white/30 text-white/80 rounded-xl text-sm font-medium hover:bg-white/10 transition-all"
            >
              Continue as Guest
            </button>
          </div>

          <div className="mt-6 text-center space-y-3">
            <Link
              to="/customer-booking-screen"
              className="block text-[#D4AF37] hover:text-[#F0C940] text-sm font-medium transition-colors"
            >
              Book as Guest →
            </Link>
            <Link
              to="/"
              className="block text-white/50 hover:text-white/80 text-xs transition-colors"
            >
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerLoginScreen;
